export const  national = [
    "汉族", "壮族", "满族", "回族", "苗族", "维吾尔族", "土家族", "彝族", "蒙古族", "藏族", "布依族", "侗族", "瑶族", "朝鲜族", "白族", "哈尼族",
    "哈萨克族", "黎族", "傣族", "畲族", "傈僳族", "仡佬族", "东乡族", "高山族", "拉祜族", "水族", "佤族", "纳西族", "羌族", "土族", "仫佬族", "锡伯族",
    "柯尔克孜族", "达斡尔族", "景颇族", "毛南族", "撒拉族", "布朗族", "塔吉克族", "阿昌族", "普米族", "鄂温克族", "怒族", "京族", "基诺族", "德昂族", "保安族",
    "俄罗斯族", "裕固族", "乌孜别克族", "门巴族", "鄂伦春族", "独龙族", "塔塔尔族", "赫哲族", "珞巴族"]
export const politicalOutlook = ['群众', '团员', '共产党员', '其它党派人士']
export const education = ['统招大专', '自考大专', '统招本科', '自考本科', '硕士', '博士']
export const arms = ['武警', '海军', '陆军', '空军']
export const liaison = ['父母', '子女', '配偶', '兄弟姐妹', '其他（她）']
export const applyPosition = [{
    value: 10,
    title: '试用经纪人'
}]
export const recruitmentSource =  ['社会招聘', '校园招聘', '部队招聘', '内部推荐', '门店招聘', '第三方推荐']
export const addressType = ['外埠城镇', '外埠农业', '本市城镇（北京）', '本市农业（北京）']
export const province =  { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外" };
export default {
    national,
    politicalOutlook,
    education,
    arms,
    liaison,
    applyPosition,
    recruitmentSource,
    addressType,
    province
}